var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrmLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 48,
    viewBox: "0 0 225 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 7,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1227 10.1678V23.4404L9.00537 19.9089V6.63623V13.6995L15.1227 10.1678Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1227 6.63623H9.00537V23.4407H15.1227V6.63623Z",
    fill: "url(#paint0_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 4,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0641 12.5757L9.56152 14.0207V19.5879L12.0641 21.0327V12.5757Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0643 12.5757H9.56152V21.0327H12.0643V12.5757Z",
    fill: "url(#paint1_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 7,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1227 10.1678V11.4861L9.00537 15.0178V6.63623V13.6995L15.1227 10.1678Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1227 6.63623H9.00537V15.0178H15.1227V6.63623Z",
    fill: "url(#paint2_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 18,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00537 13.6996V6.63634L20.5 0L26.617 3.53177L15.1226 10.1679L9.00537 13.6996Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.617 0H9.00537V13.6996H26.617V0Z",
    fill: "url(#paint3_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 15,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0831 2.03991L20.5 0.548828L9.4812 6.91048V9.89286L23.0831 2.03991Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0831 0.548828H9.4812V9.89286H23.0831V0.548828Z",
    fill: "url(#paint4_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 18,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11728 21.5762L17.6116 28.2125L11.4946 31.7443L0 25.1079L6.11728 28.6397V21.5762Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6116 21.5762H0V31.7443H17.6116V21.5762Z",
    fill: "url(#paint5_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 25,
    width: 8,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67334 25.4287V28.3185L11.4947 31.1022L13.9972 29.6571L6.67334 25.4287Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9972 25.4287H6.67334V31.1022H13.9972V25.4287Z",
    fill: "url(#paint6_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 8,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11728 21.5762L7.2589 22.2352V29.2987L0 25.1079L6.11728 28.6397V21.5762Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25867 21.5762H0V29.299H7.25867V21.5762Z",
    fill: "url(#paint7_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 7,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11728 28.6399L0 25.1082L0.000228182 11.8355L6.11728 8.30371V21.5764V28.6399Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11705 8.30371H0V28.6399H6.11705V8.30371Z",
    fill: "url(#paint8_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 4,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05885 10.6187L0.476074 12.11V24.8333L3.05885 26.3246V10.6187Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05885 10.6187H0.476074V26.3246H3.05885V10.6187Z",
    fill: "url(#paint9_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 15,
    width: 18,
    height: 11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8828 25.7658L23.3882 19.1294L29.5055 15.5977L40.9998 22.234L34.8828 18.7022V25.7658Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 15.5977H23.3882V25.7658H40.9998V15.5977Z",
    fill: "url(#paint10_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 16,
    width: 8,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 21.9127V19.0229L29.5057 16.2393L27.0029 17.6843L34.3268 21.9127Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3268 16.2393H27.0029V21.9127H34.3268V16.2393Z",
    fill: "url(#paint11_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 18,
    width: 8,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8831 25.7655L33.7415 25.1065V18.043L41.0001 22.2338L34.8831 18.702V25.7655Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 18.043H33.7415V25.7658H41.0001V18.043Z",
    fill: "url(#paint12_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 18,
    width: 7,
    height: 22
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8831 18.7021L41.0001 22.2339V35.5066L34.8831 39.0384V25.7657V18.7021Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 18.7021H34.8831V39.0384H41.0001V18.7021Z",
    fill: "url(#paint13_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 21,
    width: 4,
    height: 16
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9414 36.723L40.5242 35.2317V22.5084L37.9414 21.0171V36.723Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5242 21.0171H37.9414V36.723H40.5242V21.0171Z",
    fill: "url(#paint14_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 12,
    height: 14
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5056 12.2623L18.011 18.8986V11.8351L29.5056 5.19873L23.3883 8.73027L29.5056 12.2623Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5056 5.19873H18.011V18.8986H29.5056V5.19873Z",
    fill: "url(#paint15_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 8,
    height: 7
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.891 10.8181L23.3885 9.37305L18.5671 12.1564V15.0465L25.891 10.8181Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.891 9.37305H18.5671V15.0465H25.891V9.37305Z",
    fill: "url(#paint16_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 5,
    width: 8,
    height: 8
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5055 12.2623L28.3639 12.9213L22.2466 9.38953L29.5055 5.19873L23.3882 8.73027L29.5055 12.2623Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5052 5.19873H22.2466V12.9213H29.5052V5.19873Z",
    fill: "url(#paint17_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 5,
    width: 18,
    height: 14
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3882 8.73027L29.5055 5.19873L40.9998 11.8351V18.8984L29.5055 12.2623L23.3882 8.73027Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 5.19873H23.3882V18.8986H40.9998V5.19873Z",
    fill: "url(#paint18_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 5,
    width: 15,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5242 15.0921V12.1097L29.5056 5.74805L26.9226 7.23913L40.5242 15.0921Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5242 5.74805H26.9226V15.0923H40.5242V5.74805Z",
    fill: "url(#paint19_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 28,
    width: 12,
    height: 15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4944 35.0792L22.9888 28.4429L22.989 35.5064L11.4944 42.1427L17.6117 38.611L11.4944 35.0792Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.989 28.4429H11.4944V42.1427H22.989V28.4429Z",
    fill: "url(#paint20_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 32,
    width: 8,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1091 36.5238L17.6119 37.9689L22.433 35.1852V32.2954L15.1091 36.5238Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.433 32.2954H15.1091V37.9689H22.433V32.2954Z",
    fill: "url(#paint21_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 34,
    width: 8,
    height: 9
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4946 35.0794L12.6362 34.4204L18.7533 37.9522L11.4946 42.143L17.6119 38.6112L11.4946 35.0794Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7533 34.4204H11.4946V42.143H18.7533V34.4204Z",
    fill: "url(#paint22_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 18,
    height: 15
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6119 38.6112L11.4946 42.143L0.000244141 35.5064V28.4434L11.4946 35.0795L17.6119 38.6112Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6119 28.4434H0.000244141V42.1432H17.6119V28.4434Z",
    fill: "url(#paint23_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 32,
    width: 15,
    height: 10
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.476074 32.2495V35.2319L11.4947 41.5935L14.0777 40.1025L0.476074 32.2495Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0777 32.2495H0.476074V41.5938H14.0777V32.2495Z",
    fill: "url(#paint24_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 23,
    width: 7,
    height: 18
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8772 37.174L25.8774 23.9014L31.9947 27.4331L31.9945 40.7058V33.6423L25.8772 37.174Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9945 23.9014H25.8772V40.7058H31.9945V23.9014Z",
    fill: "url(#paint25_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 26,
    width: 4,
    height: 9
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.936 34.7659L31.4388 33.3211V27.7539L28.936 26.3091V34.7659Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4388 26.3091H28.936V34.7659H31.4388V26.3091Z",
    fill: "url(#paint26_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 32,
    width: 7,
    height: 9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8772 37.1745L25.8774 35.8565L31.9947 32.3247L31.9945 40.7063V33.6428L25.8772 37.1745Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9945 32.3247H25.8772V40.7063H31.9945V32.3247Z",
    fill: "url(#paint27_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 33,
    width: 18,
    height: 15
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9945 33.6421V40.7056L20.4999 47.342L14.3831 43.8102L25.8772 37.1739L31.9945 33.6421Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9945 33.6421H14.3831V47.3417H31.9945V33.6421Z",
    fill: "url(#paint28_linear_15_1419)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_15_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 37,
    width: 15,
    height: 10
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.917 45.3017L20.4998 46.7928L31.5188 40.4311V37.4487L17.917 45.3017Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_15_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5188 37.4487H17.917V46.7928H31.5188V37.4487Z",
    fill: "url(#paint29_linear_15_1419)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5692 34.3158C55.948 34.3158 54.4427 34.0316 53.0531 33.4631C51.6636 32.8736 50.4424 32.063 49.3897 31.0314C48.3581 29.9787 47.5581 28.7576 46.9896 27.368C46.4422 25.9784 46.1685 24.4836 46.1685 22.8835C46.1685 21.2834 46.4422 19.7886 46.9896 18.399C47.5581 17.0095 48.3581 15.7989 49.3897 14.7672C50.4424 13.7356 51.653 12.925 53.0216 12.3355C54.4111 11.746 55.927 11.4512 57.5692 11.4512C59.3377 11.4512 60.8957 11.746 62.2432 12.3355C63.5906 12.904 64.7802 13.6935 65.8118 14.7041L62.9064 17.6095C62.2958 16.9358 61.5484 16.4094 60.6641 16.0305C59.7799 15.6515 58.7482 15.462 57.5692 15.462C56.5376 15.462 55.5901 15.641 54.7269 15.9989C53.8848 16.3357 53.1479 16.841 52.5163 17.5148C51.8846 18.1674 51.4004 18.957 51.0635 19.8833C50.7267 20.7887 50.5582 21.7887 50.5582 22.8835C50.5582 23.9994 50.7267 25.01 51.0635 25.9153C51.4004 26.8206 51.8846 27.6101 52.5163 28.2839C53.1479 28.9365 53.8848 29.4418 54.7269 29.7997C55.5901 30.1577 56.5376 30.3366 57.5692 30.3366C58.8114 30.3366 59.8746 30.1471 60.7589 29.7682C61.6642 29.3892 62.4221 28.8523 63.0327 28.1575L65.9381 31.063C64.9065 32.0946 63.7064 32.8947 62.3379 33.4631C60.9694 34.0316 59.3798 34.3158 57.5692 34.3158ZM68.924 34V11.7986H73.219V34H68.924ZM82.8512 34V11.7986H87.1462V34H82.8512ZM71.64 24.431V20.6413H84.0513V24.431H71.64ZM90.0423 34L98.9797 11.7986H102.485L111.391 34H106.812L99.9271 15.7778H101.506L94.5268 34H90.0423ZM94.7794 29.8629V26.2627H106.717V29.8629H94.7794ZM114.013 34V11.7986H118.308V34H114.013ZM122.864 34V11.7986H125.865L127.159 16.0936V34H122.864ZM138.213 34L125.044 16.9463L125.865 11.7986L139.034 28.8523L138.213 34ZM138.213 34L136.981 29.8313V11.7986H141.308V34H138.213ZM162.273 34.3158C160.652 34.3158 159.147 34.0316 157.757 33.4631C156.368 32.8736 155.147 32.063 154.094 31.0314C153.062 29.9787 152.262 28.7576 151.694 27.368C151.146 25.9784 150.873 24.4836 150.873 22.8835C150.873 21.2834 151.146 19.7886 151.694 18.399C152.262 17.0095 153.062 15.7989 154.094 14.7672C155.147 13.7356 156.357 12.925 157.726 12.3355C159.115 11.746 160.631 11.4512 162.273 11.4512C164.042 11.4512 165.6 11.746 166.947 12.3355C168.295 12.904 169.484 13.6935 170.516 14.7041L167.611 17.6095C167 16.9358 166.253 16.4094 165.368 16.0305C164.484 15.6515 163.452 15.462 162.273 15.462C161.242 15.462 160.294 15.641 159.431 15.9989C158.589 16.3357 157.852 16.841 157.221 17.5148C156.589 18.1674 156.105 18.957 155.768 19.8833C155.431 20.7887 155.263 21.7887 155.263 22.8835C155.263 23.9994 155.431 25.01 155.768 25.9153C156.105 26.8206 156.589 27.6101 157.221 28.2839C157.852 28.9365 158.589 29.4418 159.431 29.7997C160.294 30.1577 161.242 30.3366 162.273 30.3366C163.516 30.3366 164.579 30.1471 165.463 29.7682C166.368 29.3892 167.126 28.8523 167.737 28.1575L170.642 31.063C169.611 32.0946 168.411 32.8947 167.042 33.4631C165.674 34.0316 164.084 34.3158 162.273 34.3158ZM176.786 24.7152V21.3676H181.934C182.987 21.3676 183.797 21.1045 184.366 20.5781C184.955 20.0307 185.25 19.2833 185.25 18.3359C185.25 17.4727 184.955 16.7568 184.366 16.1884C183.797 15.5989 182.987 15.3041 181.934 15.3041H176.786V11.7986H182.313C183.745 11.7986 184.997 12.0829 186.071 12.6513C187.166 13.1987 188.008 13.9567 188.598 14.9251C189.208 15.8936 189.513 17.0095 189.513 18.2727C189.513 19.5781 189.208 20.715 188.598 21.6834C188.008 22.6309 187.166 23.3783 186.071 23.9257C184.976 24.452 183.703 24.7152 182.25 24.7152H176.786ZM173.628 34V11.7986H177.923V34H173.628ZM185.755 34L178.429 24.3994L182.376 23.1677L190.966 34H185.755ZM193.397 34V11.7986H196.429L205.43 26.1995H203.693L212.662 11.7986H215.693V34H211.43V19.157L212.251 19.4096L205.998 29.4523H203.093L196.84 19.4096L197.692 19.157V34H193.397Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_1419",
    x1: 7.34558,
    y1: 4.1479,
    x2: 19.4458,
    y2: 5.89458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_1419",
    x1: 8.88245,
    y1: 11.3234,
    x2: 13.8675,
    y2: 11.9084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_1419",
    x1: 7.34558,
    y1: 5.39512,
    x2: 18.7432,
    y2: 8.69375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_1419",
    x1: 4.22683,
    y1: -2.02858,
    x2: 32.4538,
    y2: 12.3608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15_1419",
    x1: 5.79063,
    y1: -0.834796,
    x2: 26.3919,
    y2: 11.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15_1419",
    x1: -4.77854,
    y1: 20.0705,
    x2: 19.3851,
    y2: 36.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15_1419",
    x1: 4.68617,
    y1: 24.5886,
    x2: 16.4043,
    y2: 30.5871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15_1419",
    x1: -1.96948,
    y1: 20.4326,
    x2: 10.8999,
    y2: 25.2291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15_1419",
    x1: -1.65973,
    y1: 5.29241,
    x2: 10.5189,
    y2: 6.74505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15_1419",
    x1: -0.224706,
    y1: 8.29299,
    x2: 4.96848,
    y2: 8.63163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15_1419",
    x1: 18.6096,
    y1: 14.092,
    x2: 42.7733,
    y2: 30.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15_1419",
    x1: 25.0158,
    y1: 15.3992,
    x2: 36.7339,
    y2: 21.3976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15_1419",
    x1: 31.772,
    y1: 16.8994,
    x2: 44.6413,
    y2: 21.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15_1419",
    x1: 33.2233,
    y1: 15.6908,
    x2: 45.4019,
    y2: 17.1435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15_1419",
    x1: 37.2406,
    y1: 18.6914,
    x2: 42.4338,
    y2: 19.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15_1419",
    x1: 14.8922,
    y1: 3.17011,
    x2: 35.7894,
    y2: 10.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15_1419",
    x1: 16.58,
    y1: 8.53295,
    x2: 28.2981,
    y2: 14.5314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15_1419",
    x1: 20.2771,
    y1: 4.05521,
    x2: 33.1464,
    y2: 8.85183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_15_1419",
    x1: 18.6096,
    y1: 3.17011,
    x2: 46.8368,
    y2: 17.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_15_1419",
    x1: 23.2321,
    y1: 4.36439,
    x2: 43.8335,
    y2: 16.2557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_15_1419",
    x1: 8.37557,
    y1: 26.4143,
    x2: 29.2728,
    y2: 33.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_15_1419",
    x1: 13.122,
    y1: 31.4553,
    x2: 24.8401,
    y2: 37.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_15_1419",
    x1: 9.52514,
    y1: 33.2769,
    x2: 22.3944,
    y2: 38.0735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_15_1419",
    x1: -4.7783,
    y1: 26.4147,
    x2: 23.4489,
    y2: 40.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_15_1419",
    x1: -3.21443,
    y1: 30.8659,
    x2: 17.3869,
    y2: 42.7571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_15_1419",
    x1: 24.2174,
    y1: 21.413,
    x2: 36.3176,
    y2: 23.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_15_1419",
    x1: 28.257,
    y1: 25.0568,
    x2: 33.242,
    y2: 25.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_15_1419",
    x1: 24.2174,
    y1: 31.0836,
    x2: 35.6151,
    y2: 34.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_15_1419",
    x1: 9.60458,
    y1: 31.6135,
    x2: 37.8314,
    y2: 46.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_15_1419",
    x1: 14.2264,
    y1: 36.0651,
    x2: 34.8277,
    y2: 47.9568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#1CA4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8026,
    stopColor: "#0021CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLogo2);
export default __webpack_public_path__ + "static/media/crmLogo2.fa5074e813bcfa657b447d27ba038597.svg";
export { ForwardRef as ReactComponent };